<template>
  <div
    class="modal fade"
    id="create-mou-moa-modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <div>
              <h5 class="modal-title mb-0">
                {{ editMode ? "Update Document" : "Add MOU/MOA Document" }}
              </h5>
              <small class="text-muted">
                Upload the soft copy (PDF) — it will be stored on Google Drive.
              </small>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <label><span class="text-danger">*</span> Title / Subject</label>
              <textarea
                v-model="form.title"
                class="form-control"
                rows="3"
                placeholder="Enter document title"
                required
              ></textarea>
            </div>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label><span class="text-danger">*</span> Document Type</label>
                <select v-model="form.document_type" class="form-control" required>
                  <option value="mou">MOU (Memorandum of Understanding)</option>
                  <option value="moa">MOA (Memorandum of Agreement)</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label><span class="text-danger">*</span> CHED Caraga's Role</label>
                <select v-model="form.party_role" class="form-control" required>
                  <option value="first_party">First / Initiating Party</option>
                  <option value="partner">Partner / Co-signatory</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label><span class="text-danger">*</span> Status</label>
                <select v-model="form.status" class="form-control" required>
                  <option value="active">Active</option>
                  <option value="expired">Expired</option>
                  <option value="terminated">Terminated</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label><span class="text-danger">*</span> Counterpart / Other Party</label>
              <input
                v-model="form.counterpart"
                type="text"
                class="form-control"
                placeholder="e.g. Caraga State University"
                required
              />
            </div>

            <div class="form-group">
              <label>Purpose / Description</label>
              <textarea
                v-model="form.purpose"
                class="form-control"
                rows="2"
                placeholder="Brief description of what the MOU/MOA covers"
              ></textarea>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label><span class="text-danger">*</span> Date Signed</label>
                <input v-model="form.date_signed" type="date" class="form-control" required />
              </div>
              <div class="form-group col-md-6">
                <label>Expiry Date <small class="text-muted">(if applicable)</small></label>
                <input v-model="form.expiry_date" type="date" class="form-control" />
              </div>
            </div>

            <div class="form-group mb-0">
              <label>
                <span class="text-danger" v-if="!editMode">*</span> Soft Copy (PDF)
              </label>
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  id="mou-moa-file-input"
                  accept=".pdf,application/pdf"
                  @change="onFileChange"
                />
                <label class="custom-file-label" for="mou-moa-file-input">
                  {{ selectedFile ? selectedFile.name : "Choose PDF file" }}
                </label>
              </div>
              <small v-if="editMode && existingPath" class="form-text text-muted">
                Leave empty to keep the current file on Drive.
              </small>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
              {{ editMode ? "Save Changes" : "Upload Document" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateMouMoaModal",
  data() {
    return {
      editMode: false,
      editingId: null,
      saving: false,
      selectedFile: null,
      existingPath: "",
      form: {
        title: "",
        document_type: "mou",
        party_role: "first_party",
        counterpart: "",
        purpose: "",
        date_signed: "",
        expiry_date: "",
        status: "active",
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        title: "",
        document_type: "mou",
        party_role: "first_party",
        counterpart: "",
        purpose: "",
        date_signed: new Date().toISOString().slice(0, 10),
        expiry_date: "",
        status: "active",
      };
      this.selectedFile = null;
      this.existingPath = "";
      this.editingId = null;
      this.editMode = false;
      const input = document.getElementById("mou-moa-file-input");
      if (input) input.value = "";
    },
    openCreate() {
      this.resetForm();
      $("#create-mou-moa-modal").modal("show");
    },
    openEdit(doc) {
      this.editMode = true;
      this.editingId = doc.id;
      this.existingPath = doc.path || "";
      this.form = {
        title: doc.title || "",
        document_type: doc.document_type || "mou",
        party_role: doc.party_role || "first_party",
        counterpart: doc.counterpart || "",
        purpose: doc.purpose || "",
        date_signed: doc.date_signed ? doc.date_signed.slice(0, 10) : "",
        expiry_date: doc.expiry_date ? doc.expiry_date.slice(0, 10) : "",
        status: doc.status || "active",
      };
      this.selectedFile = null;
      $("#create-mou-moa-modal").modal("show");
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0] || null;
    },
    submit() {
      if (!this.editMode && !this.selectedFile) {
        toastr.error("Please attach a PDF file.", "Error");
        return;
      }

      this.saving = true;
      const fd = new FormData();
      fd.append("title", this.form.title);
      fd.append("document_type", this.form.document_type);
      fd.append("party_role", this.form.party_role);
      fd.append("counterpart", this.form.counterpart);
      fd.append("purpose", this.form.purpose || "");
      fd.append("date_signed", this.form.date_signed);
      fd.append("expiry_date", this.form.expiry_date || "");
      fd.append("status", this.form.status);
      if (this.selectedFile) {
        fd.append("file", this.selectedFile);
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      const request = this.editMode
        ? axios.post(`api/mou-moa/${this.editingId}`, fd, config)
        : axios.post("api/mou-moa", fd, config);

      request
        .then((res) => {
          toastr.success(
            (res.data && res.data.message) || "Saved successfully.",
            "Information"
          );
          $("#create-mou-moa-modal").modal("hide");
          this.$emit("saved");
        })
        .catch((error) => {
          const msg =
            (error.response && error.response.data.message) ||
            "Something went wrong.";
          toastr.error(msg, "Error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
